import { ReactNode, Suspense } from 'react';

export const LazyWrapper = ({ children }: { children: ReactNode }) => <Suspense fallback={null}>{children}</Suspense>;
